import { render, staticRenderFns } from "./CommentScreenCreator.vue?vue&type=template&id=51f7917b&scoped=true"
import script from "./CommentScreenCreator.vue?vue&type=script&lang=ts"
export * from "./CommentScreenCreator.vue?vue&type=script&lang=ts"
import style0 from "./CommentScreenCreator.vue?vue&type=style&index=0&id=51f7917b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7917b",
  null
  
)

export default component.exports